
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { fetchBotDetails } from '@/services/bot-service';
import { fetchDetailedBotAccounts } from '@/services/bot-account-service';
import { Bot, DetailedBotAccount } from '@/types/trader';

export const useBotData = (botId: string | undefined) => {
  const { user } = useAuth();
  
  // Fetch bot details
  const { 
    data: bot, 
    isLoading: isBotLoading,
    error: botError
  } = useQuery({
    queryKey: ['bot', botId],
    queryFn: async (): Promise<Bot | null> => {
      if (!botId || !user?.id) return null;
      return fetchBotDetails(botId, user.id);
    },
    enabled: !!botId && !!user?.id,
  });

  // Fetch detailed connected accounts
  const { 
    data: connectedAccounts = [],
    isLoading: isAccountsLoading 
  } = useQuery({
    queryKey: ['detailedBotAccounts', botId],
    queryFn: async (): Promise<DetailedBotAccount[]> => {
      if (!botId || !user?.id) return [];
      return fetchDetailedBotAccounts(botId, user.id);
    },
    enabled: !!botId && !!user?.id,
  });

  return {
    bot,
    connectedAccounts,
    isLoading: isBotLoading || isAccountsLoading,
    error: botError
  };
};
